import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class MissingTranslationHandlerLogger implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams) {
      console.warn(`Missing translation for message \"${params.key}\" with params:`, params.interpolateParams);
    } else {
      console.warn(`Missing translation for message \"${params.key}\"`);
    }

    return params.key;
  }
}
